import { useCanUseTool } from './useCanUseTool';

export const useTariffToolCheck = (tool: string) => {
  const { allowed } = useCanUseTool(tool);

  return allowed;
};
